{
  "version": 1,
  "asset_id": "87908abe-f67b-4a60-bb8e-57805c7ae34e",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/87908abe-f67b-4a60-bb8e-57805c7ae34e/clip-img_0015-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/87908abe-f67b-4a60-bb8e-57805c7ae34e/clip-img_0015-poster-sm.webp",
  "original_filename": "clip-img_0015-poster-sm.webp",
  "size": 23374,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:05Z"
}
